import React, { useState } from "react";
import SortableTh from "./SortableTh";
import { SORT_ORDER } from "../../../models/Sorting";

// A standalone column enum just for the example.
enum DEMO_COLUMN {
	NAME = "NAME",
	CREATED = "CREATED",
	STATUS = "STATUS",
}

/**
 * Live example for the SortableTh primitive — a clickable, sort-aware table
 * header cell. Click a header to cycle ascending → descending; the inactive
 * columns reset to the neutral indicator.
 */
const SortableThExample: React.FC = () => {
	const [sort, setSort] = useState<DEMO_COLUMN | undefined>(DEMO_COLUMN.NAME);
	const [order, setOrder] = useState<SORT_ORDER>(SORT_ORDER.ASC);

	const onSort = (column: DEMO_COLUMN) => {
		if (sort !== column) {
			setSort(column);
			setOrder(SORT_ORDER.ASC);
		} else {
			setOrder((prev) => (prev === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC));
		}
	};

	return (
		<div className="max-w-xl">
			<table className="w-full border-collapse">
				<thead className="border-b-2 border-border">
					<tr className="text-left bg-muted text-sm font-medium whitespace-nowrap">
						<SortableTh
							label="Name"
							column={DEMO_COLUMN.NAME}
							activeColumn={sort}
							order={order}
							onSort={onSort}
							width="50%"
							className="pl-6"
						/>
						<SortableTh
							label="Created"
							column={DEMO_COLUMN.CREATED}
							activeColumn={sort}
							order={order}
							onSort={onSort}
							width="30%"
						/>
						<SortableTh
							label="Status"
							column={DEMO_COLUMN.STATUS}
							activeColumn={sort}
							order={order}
							onSort={onSort}
							width="20%"
						/>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="px-4 py-2 border-t border-border pl-6">Acme AB</td>
						<td className="px-4 py-2 border-t border-border">2026-01-12</td>
						<td className="px-4 py-2 border-t border-border">Active</td>
					</tr>
					<tr>
						<td className="px-4 py-2 border-t border-border pl-6">Globex</td>
						<td className="px-4 py-2 border-t border-border">2026-03-04</td>
						<td className="px-4 py-2 border-t border-border">Inactive</td>
					</tr>
				</tbody>
			</table>

			<p className="mt-4 text-sm text-muted-foreground">
				Active column: <b>{sort ?? "none"}</b> — order: <b>{order}</b>
			</p>
		</div>
	);
};

export default SortableThExample;
